import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';
import { actions as pinsActions, selectors as pinsSelectors } from 'modules/pins';
import { actions as venuesActions, selectors as venuesSelectors } from 'modules/venues';
import config from 'config/index';

import MapPage from '../components/MapPage';

const shouldReRoute = (oldProps, newProps) =>
    !oldProps.location.pathname.includes(config.routes.pins) &&
    !newProps.location.pathname.includes(config.routes.pins);

export default compose(
    connect(
        state => {
            const pinsPending = pinsSelectors.selectListPending(state);
            const venuesPending = venuesSelectors.selectListPending(state);
            return {
                showLoader: pinsPending || venuesPending,
            };
        },
        dispatch => ({
            read: () => {
                dispatch(pinsActions.pinsRequest());
                dispatch(venuesActions.venuesRequest());
            },
        }),
    ),
    routeDependencies({
        shouldReRoute,
    }),
    loadable,
)(MapPage);
